import React from 'react';
import Base from './Base';
import Group from './Group';

class Select extends Base {
  render() {
    let inputClass = '';
    if (this.state.focus === true) {
      inputClass = 'is-active';
    }
    // console.info('this.state.value', this.state.value, this.props.name);
    if (
      ['integer', 'float'].includes(this.props.filters) &&
      !isNaN(this.state.value) &&
      this.state.value != null
    ) {
      inputClass = 'is-active';
    } else if (
      !['integer', 'float'].includes(this.props.filters) &&
      this.state.value !== '' &&
      this.state.value !== null
    ) {
      inputClass = 'is-active';
    }
    const inputID = this.getInputID();
    const options = this.props.options.map(option => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ));
    return (
      <Group
        inputID={inputID}
        errors={this.state.errors}
        className={inputClass}
        {...this.props}
      >
        <div className={`select ${inputClass}`}>
          <select
            className={`form-m__input ${inputClass}`}
            id={inputID}
            name={this.getInputName()}
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            value={this.state.value == null ? '' : this.state.value}
            onChange={this.onChange}
            disabled={this.props.disabled}
            readOnly={this.props.readOnly}
          >
            {options}
          </select>
        </div>
      </Group>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/Form/Input/Select.js